import { forwardRef } from 'react'

const TOOLTIP_BASE_CLASSES =
  'absolute min-w-[94px] text-center bg-white font-["Ultramarine"] shadow-[0px_15px_40px_-5px_rgba(82,82,82,0.26)] font-medium border-0 rounded-[5px] pointer-events-none before-tooltip'

export const GraphTooltip = forwardRef(function GraphTooltip({ show, testId }, ref) {
  if (!show) return null
  return <div className={TOOLTIP_BASE_CLASSES} ref={ref} data-testid={`tooltip-${testId}`} />
})

export const TOOLTIP_PSEUDO_STYLES = `
.before-tooltip:after {
  content: "";
  position: absolute;
  border-width: 9px;
  border-style: solid;
  margin-left: 8px;
  top: 90%;
  left: 35%;
  border-color: rgb(255, 255, 255) rgb(255, 255, 255) transparent transparent;
  transform: rotate(-90deg);
}`
